(() => {
  document.querySelectorAll('[data-rz-header-search]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('input[type="search"]');
    const panel = root.querySelector('.rz-header-results');
    const status = panel.querySelector('[role="status"]');
    const list = panel.querySelector('ul');
    let timer, controller, revision = 0;
    const close = () => { panel.hidden = true; };
    const search = async () => {
      const current = ++revision;
      controller?.abort();
      const query = input.value.trim();
      list.replaceChildren();
      if (!query) { close(); return; }
      panel.hidden = false;
      status.textContent = root.dataset.searching;
      controller = new AbortController();
      try {
        const url = new URL(root.dataset.endpoint, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (current !== revision) return;
        const products = data.resources?.results?.products || [];
        status.textContent = products.length ? root.dataset.results.replace('{count}', String(products.length)) : root.dataset.none;
        products.forEach(product => {
          const url = new URL(product.url, location.origin);
          if (url.origin !== location.origin) return;
          ;
          const source = new URLSearchParams(location.search).get('source');
          if (source) url.searchParams.set('source', source);
          const link = document.createElement('a');
          link.href = url.href;
          link.textContent = product.title;
          const item = document.createElement('li');
          item.append(link); list.append(item);
        });
      } catch (error) {
        if (error.name !== 'AbortError' && current === revision) status.textContent = root.dataset.unavailable;
      }
    };
    input.addEventListener('input', () => { clearTimeout(timer); ++revision; controller?.abort(); if (!input.value.trim()) close(); timer = setTimeout(search, 220); });
    root.querySelector('form').addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); search(); });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { ++revision; controller?.abort(); clearTimeout(timer); close(); input.focus(); }
      if (event.key === 'ArrowDown' && event.target === input) { const first = list.querySelector('a'); if (first) { event.preventDefault(); first.focus(); } }
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) { ++revision; controller?.abort(); clearTimeout(timer); close(); } });
    root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0));
  });
})();
